import { render } from "./BangladeshiVolunteer.vue?vue&type=template&id=7d9184e8&scoped=true"
import script from "./BangladeshiVolunteer.vue?vue&type=script&lang=js"
export * from "./BangladeshiVolunteer.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-7d9184e8"

export default script